import { render, staticRenderFns } from "./ChangePasswordTemplate.vue?vue&type=template&id=9f5981a6"
import script from "./ChangePasswordTemplate.vue?vue&type=script&lang=js"
export * from "./ChangePasswordTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports